import {
  ComponentProps,
  forwardRef,
  PropsWithChildren,
  ReactNode,
} from 'react';

import { cx } from '../utils';

export const Panel = forwardRef(
  ({ children, header, footer,panelid, iscollapse, className, classNames = {}, ...props }, ref) => {

    let paneltarget = "";
    if(panelid){
      paneltarget = "panel-"+panelid;
    }

    let buttonclass = "ais-Panel-header";
    if(iscollapse){
      buttonclass = "accordion-button ais-Panel-header collapsed";
    }
    else if(iscollapse == 'open'){
      buttonclass = "accordion-button ais-Panel-header";
    }

    return (
      <div
        {...props}
        className={cx('ais-Panel', classNames.root, className)}
        ref={ref}
      >
        {header && (
          <div data-bs-toggle="collapse" data-bs-target={"#"+paneltarget} className={cx(buttonclass, classNames.header)}>
            {header}
          </div>
        )}
        <div id={paneltarget} className={cx('ais-Panel-body', classNames.body) + " "+iscollapse}>{children}</div>
        {footer && (
          <div className={cx('ais-Panel-footer', classNames.footer)}>
            {footer}
          </div>
        )}
      </div>
    );
  }
);
